import { isOfflineModeEntitled } from './offlineEntitlement';

const SCOPED_OPTIMISTIC_ROUTE_PATTERNS = ['/data/', '/projects/', '/calendar/'];

const SENSITIVE_ONLINE_REQUIRED_PATTERNS = [
	'/settings/',
	'/auth/',
	'/login',
	'/logout',
	'/payment',
	'/billing',
	'/subscription',
	'/mfa',
	'/password',
	'/integrations/',
	'/user/switch-company',
	'/switch-company',
];

const MUTATION_METHODS = new Set(['post', 'put', 'patch', 'delete']);

export const normalizeRoute = (url?: string): string => {
	if (!url) {
		return '';
	}

	return url.toLowerCase();
};

export const isScopedOptimisticRoute = (url?: string): boolean => {
	const normalizedUrl = normalizeRoute(url);
	return SCOPED_OPTIMISTIC_ROUTE_PATTERNS.some((pattern) =>
		normalizedUrl.includes(pattern)
	);
};

export const isSensitiveOnlineRequiredRoute = (url?: string): boolean => {
	const normalizedUrl = normalizeRoute(url);
	return SENSITIVE_ONLINE_REQUIRED_PATTERNS.some((pattern) =>
		normalizedUrl.includes(pattern)
	);
};

export const isMutationMethod = (method?: string): boolean => {
	if (!method) {
		return false;
	}

	return MUTATION_METHODS.has(method.toLowerCase());
};

export const shouldQueueOfflineMutation = (
	url?: string,
	method?: string
): boolean => {
	if (!isOfflineModeEntitled()) {
		return false;
	}
	return isScopedOptimisticRoute(url) && isMutationMethod(method);
};
